import React from 'react'

import HeaderDropdown from './HeaderDropdown'
import { useWishlistContext } from 'store/WishlistContext'
import CustomWishlist from 'components/Icons/customWishlist'
import HeaderWishlistItem from '../components/HeaderWishlistItem'

const WishlistDropdown = ({ open, onClose }) => {
  const { wishlistProducts } = useWishlistContext()

  return (
    <HeaderDropdown
      open={open}
      onClose={onClose}
      title="ჩემი სურვილების სია"
      items={wishlistProducts}
      emptyIcon={CustomWishlist}
      emptyTitle="სურვილების სია ცარიელია"
      emptyMessage="გთხოვთ აირჩიოთ პროდუქცია"
      buttonText="ყველას ნახვა"
      buttonRoute="/wishlist"
      rightOffset="right-[-50px] md:-right-6"
      tooltipRightOffset="right-[63px] md:right-[36px]"
      renderItem={product => <HeaderWishlistItem product={product} />}
    />
  )
}

export default WishlistDropdown
